export type SearchQueryTextPart = {
    text: string;
    highlighted: boolean;
};

export const splitTextBySearchQuery = (text: string, query: string): SearchQueryTextPart[] => {
    const q = query.trim();
    if (!q || !text) {
        return text ? [{ text, highlighted: false }] : [];
    }

    const needle = q.toLowerCase();
    const parts: SearchQueryTextPart[] = [];
    let remaining = text;

    while (remaining.length > 0) {
        const idx = remaining.toLowerCase().indexOf(needle);
        if (idx === -1) {
            parts.push({ text: remaining, highlighted: false });
            break;
        }
        if (idx > 0) {
            parts.push({ text: remaining.slice(0, idx), highlighted: false });
        }
        parts.push({ text: remaining.slice(idx, idx + q.length), highlighted: true });
        remaining = remaining.slice(idx + q.length);
    }

    return parts;
};
